export default "__VITE_ASSET__c13de816__"